import React from "react";
import Goalcomp from "../../../../assets/images/goalcomp.svg";
import Goalprogress from "../../../../assets/images/goalprogress.svg";
import Goalrisk from "../../../../assets/images/goalrisk.svg";

const GoalAction = () => {
  return (
    <div className="goalaction_sec">
      <div className="files_grid">
        <div className="common_card_file cir_card cursor-pointer">
          <div className="common_card_txt mb-0 ">
            <p>Complete</p>
            <h2>0 of 1 goals</h2>
          </div>
          <div className="common_card_icon">
            <div className="icon_color_bg red">
              <img src={Goalcomp} alt="score" />
            </div>
          </div>
        </div>
        <div className="common_card_file">
          <div className="common_card_txt mb-0">
            <p>In Progress</p>
            <h2>1 of 1 goals</h2>
          </div>
          <div className="common_card_icon">
            <div className="icon_color_bg green">
              <img src={Goalprogress} alt="resourceicon" />
            </div>
          </div>
        </div>
        <div className="common_card_file cursor-pointer">
          <div className="common_card_txt mb-0">
            <p>At Risk</p>
            <h2>0 of 1 goals</h2>
          </div>
          <div className="common_card_icon">
            <div className="icon_color_bg blue">
              <img src={Goalrisk} alt="filesforreviewicon" />
            </div>
          </div>
        </div>
      </div>
      <div className="qep_grad">
        <h2>Goals & Action</h2>
        <button type="button">Edit Goal </button>
      </div>
      <form action="">
        <div className="row">
          <div className="col-lg-6">
            <div className="goal_left">
              <label className="form-label">Goal Type</label>
              <select
                className="form-select mb-3"
                aria-label="Default select example"
              >
                <option selected>Training Compliance</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
              <div className="mb-3">
                <label className="form-label">
                  Objective 
                  <span className="sep_cont">(clear target with timeline)</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Reduce overdue trainings from 20% to <5% by Dec 2025"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Actions 
                  <span className="sep_cont">
                    (include assigned staff and deadlines)
                  </span>
                </label>
                <div className="d-flex gap-3">
                  <textarea
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows={3}
                    placeholder="Implement LMS with alerts – IT/Training – Due July 1"
                  ></textarea>
                  <textarea
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows={3}
                    placeholder="Supervisors track training weekly – Supervisors – Ongoing"
                  >
                    Supervisors track training weekly – Supervisors – Ongoing
                  </textarea>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="goal_right">
              <div className="mb-3">
                <label className="form-label">Goal</label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Improve staff training compliance"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Benchmarks 
                  <span className="sep_cont">(include due dates)</span>
                </label>
                <div className="d-flex gap-2 goal_multifield">
                  <input
                    type="text"
                    className="form-control text_inpt"
                    id="exampleFormControlInput1"
                    placeholder="Q2: 15%"
                  />
                  <input
                    type="Date"
                    className="form-control date_field"
                    id="exampleFormControlInput1"
                    placeholder="Due Date"
                  />
                  <input
                    type="text"
                    className="form-control text_inpt"
                    id="exampleFormControlInput1"
                    placeholder="Q3: 10%"
                  />
                  <input
                    type="Date"
                    className="form-control date_field"
                    id="exampleFormControlInput1"
                    placeholder="Due Date"
                  />
                  <input
                    type="text"
                    className="form-control text_inpt"
                    id="exampleFormControlInput1"
                    placeholder="Q4: <5%"
                  />
                  <input
                    type="Date"
                    className="form-control date_field"
                    id="exampleFormControlInput1"
                    placeholder="Due Date"
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Stabilization Plan</label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={3}
                  placeholder="Embed training compliance check into annual review"
                ></textarea>
              </div>
            </div>
          </div>
          <div className="col-12">
            <label className="form-label">Status</label>
            <select
              className="form-select mb-3"
              aria-label="Default select example"
            >
              <option selected>In Progress</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
            <div className="goalsave_btn ">
              <input
                type="submit"
                className="form-control"
                id="exampleFormControlInput1"
                value="save"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default GoalAction;
